/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
/* Components */
import Button from "../button/button";
/* Styles */
import "./chat.css";
/* Assets */
import shaia from "../../assets/Shaia.png";
import userImg from "../../assets/Img_profile.svg";
import { useMutation } from "react-query";
import { fetchChatGPT } from "../../services/chat.service";
import { useMixPanel } from "../../hooks/useMixPanel";
import useQuery from "../../hooks/useQuery";
import useChatGPTStore from "../../store/useChatGPT.store";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useUserStore from "../../store/useUser.store";
import { storeUsage } from "../../services/useCaseUsage.service";
import useUsageStore from "../../store/useUsageStore";
import { Remarkable } from "remarkable";
import useCaseStore from "../../store/useCaseStore";
import { getSessionById } from "../../services/teacherSession.service";
import { v4 as uuidv4 } from "uuid";

export const typesAllowed = ["actividad-clase-conversacion", "proyecto"];

const hito = `### Hitos para \"El Tapiz de las Creencias\"\n\n#### Hito 1: Lanzamiento del Proyecto\n- **Nombre**: Inspirando el Tapiz\n- **Duración**: 1 clase\n- **Experiencias de aprendizaje**:\n  - Revisión de las creencias y prácticas propias.\n  - Introducción a las religiones a través del libro \"God is Not One\".\n  - Discusión sobre la importancia de la alfabetización religiosa.\n- **Necesidades de aprendizaje anticipadas**:\n  - Entender las bases del Catolicismo.\n  - Curiosidad sobre otras religiones y prácticas.\n\n#### Hito 2: Búsqueda e Investigación\n- **Nombre**: Explorando Creencias\n- **Duración**: 3 clases\n- **Experiencias de aprendizaje**:\n  - Uso de Knowledge Forum para iniciar la investigación.\n  - Análisis de textos y recursos online.\n  - Elevator pitch de las religiones elegidas.\n- **Necesidades de aprendizaje anticipadas**:\n  - Técnicas de investigación efectivas.\n  - Identificar fuentes fiables en internet.\n\n#### Hito 3: Desarrollo del Ensayo Analítico\n- **Nombre**: Reflexiones Profundas\n- **Duración**: 2 clases\n- **Experiencias de aprendizaje**:\n  - Talleres de escritura analítica.\n  - Peer review de los borradores.\n  - Sesiones de edición guiada por la IA.\n- **Necesidades de aprendizaje anticipadas**:\n  - Comprensión de la estructura de un ensayo analítico.\n  - Habilidad para realizar crítica constructiva.\n\n#### Hito 4: Creación del Documental\n- **Nombre**: Narrativas Visuales\n- **Duración**: 3 clases\n- **Experiencias de aprendizaje**:\n  - Taller sobre narrativa y producción de documentales.\n  - Planeación y storyboard en equipos.\n  - Rodaje y edición del documental colaborativo.\n- **Necesidades de aprendizaje anticipadas**:\n  - Conocimiento de técnicas de narración visual.\n  - Uso de herramientas digitales para la edición de video.\n\n#### Hito 5: Preparación para la Proyección\n- **Nombre**: Ensayo General\n- **Duración**: 1 clase\n- **Experiencias de aprendizaje**:\n  - Revisión y ajuste de los documentales.\n  - Preparativos logísticos para el evento comunitario.\n  - Ensayo de presentaciones orales.\n- **Necesidades de aprendizaje anticipadas**:\n  - Manejo de nerviosismo al hablar en público.\n  - Coordinación de eventos.\n\n#### Hito 6: Cierre y Proyección Comunitaria\n- **Nombre**: El Tapiz Revelado\n- **Duración**: 1 clase\n- **Experiencias de aprendizaje**:\n  - Montaje de la muestra del tapiz visual en la comunidad.\n  - Proyección de documentales y discusión abierta.\n  - Reflexión grupal e individual sobre el aprendizaje alcanzado.\n- **Necesidades de aprendizaje anticipadas**:\n  - Habilidades de presentación y exposición.\n  - Evaluación crítica del proceso de aprendizaje.\n\n---\n\n¿Te gustan estas ideas para proceder?`;

// const message2 =
//   'Entendido, te preparo entonces el registro de los productos elegidos y la forma de compartir el proyecto:\n\njson\n{"majorProducts":{"individualProducts":["Mapa conceptual de principios geométricos"],"teamProducts":["Video documental del making-of del estadio"]},"makingItPublic":"Publicar en blog de clase"}\n``` \n\n¡Excelente trabajo en la definición de los productos del proyecto! Con esto ya tienes un punto de partida claro para comenzar a implementar el Aprendizaje Basado en Proyectos con tus estudiantes. ¡Manos a la obra!';

const ChatABP = () => {
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [messagesStep1, setMessagesStep1] = useState([]);
  const [messagesStep2, setMessagesStep2] = useState([]);
  const [messagesStep3, setMessagesStep3] = useState([]);
  const [resMessages, setResMessages] = useState([]);
  const [historyById, setHistoryById] = useState(null);
  const { sendEvent } = useMixPanel();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { user } = useUserStore();
  const { setUsage } = useUsageStore();
  const stepsRef = useRef(1);
  const temporalUserMessageRef = useRef(null);
  const temporalLoadingRef = useRef(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("sessionId");
  const { useCaseList } = useCaseStore();
  const sessionIdRef = useRef(null);
  const parentSessionIdRef = useRef(null);
  const md = new Remarkable({
    html: true,
    breaks: true,
    typographer: true,
  });
  const currentUseCase = useCaseList?.find(
    (e) => e.description === `abp${stepsRef.current}`
  );
  const useCaseId = currentUseCase ? currentUseCase.id : null;
  const { messages, setMessages, setClear } = useChatGPTStore();

  const query = useQuery();
  const type = query.get("type") || "coaching";

  useEffect(() => {
    if (sessionId) {
      sessionByIdMutation.mutate(sessionId);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (resMessages.length) {
      setMessagesByStep(resMessages);
      setNewMessage("");
      if (temporalLoadingRef.current) temporalLoadingRef.current = false;
      const messageAssistands = resMessages.filter(
        (e) => e?.role === "assistant" || e?.type === "ai"
      );
      if (sessionIdRef.current) {
        sessionByIdMutation.mutate(sessionIdRef.current);
      }
      if (messageAssistands.length) {
        const lastAssistand = messageAssistands[messageAssistands.length - 1];
        setMessages([...messages, { ...lastAssistand }]);
        console.log(
          "`before <stage_${stepsRef.current}>` ",
          `<stage_${stepsRef.current}>`
        );
        if (
          lastAssistand?.content?.includes(`<stage_${stepsRef.current}>`) ||
          lastAssistand?.data?.content.includes(`<stage_${stepsRef.current}>`)
        ) {
          console.log(
            "`after <stage_${stepsRef.current}>` ",
            `<stage_${stepsRef.current}>`
          );
          if (stepsRef.current === 3 && historyById) {
            // console.log('historyById ', historyById);
            // const historyStep1 = historyById?.history.find(e => e.useCase.step === 1);
            // const historyStep1Messages = historyStep1 ? JSON.parse(historyStep1.memory_array) : [];
            // const historyStep2 = historyById?.history.find(e => e.useCase.step === 2);
            // const historyStep2Messages = historyStep2 ? JSON.parse(historyStep2?.memory_array): [];
            // const findStage1 = historyStep1Messages.find(e => e.role === 'assistant' && e.content.includes("<stage_1>"));
            // const findStage2 = historyStep2Messages.find(e => e.role === 'assistant' && e.content.includes("<stage_2>"));
            // const currentPlan = `${findStage1?.content} \n\n ${findStage2.content}  \n\n ${lastAssistand.content}`;
            // setPlan(currentPlan);
            navigate(`/editing-abp-board?sessionId=${sessionId}`);
          } else {
            const nextStep =
              stepsRef.current < 3 ? stepsRef.current + 1 : stepsRef.current;
            stepsRef.current = nextStep;
            let currentContent =
              lastAssistand?.content || lastAssistand?.data?.content;
            if (nextStep === 3) {
              const conditions = ["Context:", "contextoUsuario"];
              console.log('messages ', messages);
              const findUserContext = messages.find(
                (e) =>
                  (e?.role === "user" || e?.type === "human") &&
                  conditions.some((s) => e?.content?.includes(s) || e?.data?.content?.includes(s))
              );

              const findStage2 = messages.find(
                (e) => e.role === "assistant" && (e?.content.includes("<stage_1>") || e?.data?.content.includes("<stage_1>"))
              );
              currentContent = `${
                findUserContext?.content || findUserContext?.data?.content
              } + ${findStage2?.content || findStage2?.data?.content} + ${
                lastAssistand?.content || lastAssistand?.data.content
              }`;
            }
            const userMessage = { role: "user", content: currentContent };
            sessionIdRef.current = uuidv4();
            const nextUseCase = useCaseList?.find(
              (e) => e.description === `abp${nextStep}`
            );
            const nextUseCaseId = nextUseCase ? nextUseCase.id : null;
            temporalLoadingRef.current = true;
            mutation.mutate({
              messages: [userMessage],
              type: `abp${nextStep}`,
              parent_session_id: sessionId,
              session_id: sessionIdRef.current,
              use_case_id: nextUseCaseId,
              lang: i18n.language
            });
            parentSessionIdRef.current = sessionId
            navigate(`/interation-abp?sessionId=${sessionIdRef.current}`);
          }
        }
      }

      setLoading(false);
    }
  }, [resMessages]);

  const getCurrentStepByUseCase = (slug) => {
    switch (slug) {
      case 'abp1':
        return 1
      case 'abp2':
        return 2
      case 'abp3':
        return 3
      default:
        return 1
    }
  }

  const sessionByIdMutation = useMutation(getSessionById, {
    onSuccess: (data) => {
      if (data?.data) {
        if (!resMessages.length) {
          const currentStepMessages = [];
          const currentStep = getCurrentStepByUseCase(data.data.superPower.slug);
          stepsRef.current = currentStep;
          const historyStep1Messages = JSON.parse(data?.data?.memory_array);
          currentStepMessages.push({
            step: currentStep,
            messages: historyStep1Messages,
          });
          parentSessionIdRef.current = data?.data?.parent_session_id || null
          if (data.history.length) {
            data.history.forEach((element) => {
              const historyStepMessages = JSON.parse(element.memory_array);
              currentStepMessages.push({
                step: getCurrentStepByUseCase(element.superPower.slug),
                messages: historyStepMessages,
              });
            });
          }
          const satinizedMessages = [];
          currentStepMessages
            .sort((a, b) => a.step - b.step)
            .forEach((e) => {
              satinizedMessages.push(...e.messages);
              setMessagesByInitialStep(e.step, e.messages);
            });
          setMessages(satinizedMessages);
        } else {
          setHistoryById(data);
          parentSessionIdRef.current = data?.data?.parent_session_id || null;
        }
      }
    },
    onError: (error) => {},
  });

  const mutation = useMutation(fetchChatGPT, {
    onSuccess: (res) => {
      setResMessages(res?.messages);
      scrollToBottom();
    },
    onError: () => {
      setLoading(false);
    },
  });

  const setMessagesByStep = (currentMessages) => {
    switch (stepsRef.current) {
      case 1:
        setMessagesStep1(currentMessages);
        break;
      case 2:
        setMessagesStep2(currentMessages);
        break;

      case 3:
        setMessagesStep3(currentMessages);
        break;
    }
  };

  const setMessagesByInitialStep = (initialStep, currentMessages) => {
    switch (initialStep) {
      case 1:
        setMessagesStep1(currentMessages);
        break;
      case 2:
        setMessagesStep2(currentMessages);
        break;

      case 3:
        setMessagesStep3(currentMessages);
        break;
    }
  };

  const storeUsagemutation = useMutation(storeUsage, {
    onSuccess: (data) => {
      setUsage({
        total: data?.total,
        limit: data?.limit,
        percentage: data?.usagePercentage,
      });
      navigate("/editing-abp-board");
    },
    onError: () => {},
  });

  const chatContainerRef = useRef(null);

  useEffect(() => {
    scrollToBottom();
  }, []);

  function scrollToBottom() {
    const lastMessage = chatContainerRef.current.lastElementChild;
    if (lastMessage) {
      lastMessage.scrollIntoView();
    }
  }

  const getMessagesByStep = (currentStep) => {
    switch (currentStep) {
      case 1:
        return messagesStep1;
      case 2:
        return messagesStep2;
      case 3:
        return messagesStep3;
    }
  };

  const send = () => {
    if (newMessage.trim() !== "") {
      const payload = { role: "user", content: newMessage };
      const currentPrevMessages = getMessagesByStep(stepsRef.current);
      setLoading(true);
      setMessages([...messages, { ...payload }]);
      setNewMessage("");
      sessionIdRef.current = uuidv4();
      mutation.mutate({
        messages: [...currentPrevMessages, payload],
        type: `abp${stepsRef.current}`,
        session_id: sessionId,
        parent_session_id: parentSessionIdRef.current || null,
        use_case_id: useCaseId,
        lang: i18n.language
      });
    }
  };

  const sendMessage = () => {
    send();
  };

  useEffect(() => {
    // Llama a scrollToBottom cada vez que se actualiza el estado de messages
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    // mutation.mutate({ messages: [...messages, payload], type: type });

    setMessagesStep1(messages);
    return () => {
      setClear();
    };
    // eslint - disable - next - line;
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Evita el comportamiento predeterminado de "Enter" en un textarea (añadir una nueva línea)
      send();
    }
  };

  const createMarkup = (markdown) => {
    const rawMarkup = md.render(markdown);
    return { __html: rawMarkup };
  };
  const conditions = ["<stage_1>", "<stage_2>", "<stage_3>", "contextoUsuario"];
  console.log("messages ", messages);
  return (
    <div className="main-chat max-w-full items-center justify-center xl:px-40">
      <div className="chat_wrapper !w-full">
        <div ref={chatContainerRef} className="chat_wrapper-scroll">
          {messages
            ?.filter(
              (e) =>
                !conditions.some(
                  (stage) =>
                    e?.content?.includes(stage) ||
                    e?.data?.content.includes(stage)
                )
            )
            .map((message, i) => {
              console.log("message ", message);
              return (
                <div
                  key={i}
                  className={`max-w-full chat_conversation-thread-${
                    message?.role === "user" || message?.type === "human"
                      ? "user"
                      : "ai"
                  }`}
                >
                  <div className="bubble-wrapper">
                    <div
                      className={`chat_bubble-${
                        message?.role === "user" || message?.type === "human"
                          ? "user"
                          : "ai"
                      }`}
                    >
                      <div className="group mb-2">
                        <span className="bubble-name xl:px-10">
                          {message?.role === "user" ||
                            (message.type === "human" && "Tú")}
                          {message?.role === "assistant" &&
                            message?.type === "ai" &&
                            "Shaia"}
                        </span>
                      </div>
                      <p className="bubble-message xl:px-10">
                        {["user", "assistant", "ai", "human"].includes(
                          message?.role || message?.type
                        ) && (
                          <div
                            className="chat-message-content chat-message-content-abp"
                            dangerouslySetInnerHTML={createMarkup(
                              message?.content || message?.data?.content
                            )}
                          />
                        )}
                      </p>
                    </div>
                  </div>
                  <div
                    className={`chat_avatar-${
                      message?.role === "user" ? "user" : "ai items-start"
                    }`}
                  >
                    {(message?.role === "user" ||
                      message?.type === "human") && (
                      <img src={userImg} alt="Tú" />
                    )}
                    {(message?.role === "assistant" ||
                      message?.type === "ai") && (
                      <img src={shaia} alt="Sha.ia" />
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="chat_input">
        <textarea
          className="input-box"
          placeholder={`${t("abp_chat_placeholder")} ...`}
          rows="4"
          cols="50"
          value={newMessage}
          disabled={loading}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Button
          label={
            loading || temporalLoadingRef.current ?
            <span className="typing-effect">Shaia</span> :
            t("abp_boton_enviar")
          }
          variant="primary"
          disabled={loading}
          onClick={sendMessage}
          customClassName="w-30"
        />
      </div>
    </div>
  );
};

export default ChatABP;
